<template>
  <div class="header">
    <div class="public_header">
      <div class="header_left">
        <router-link :to="{ path: '/index' }"
          ><img src="../../assets/index/logo.png" alt=""
        /></router-link>
      </div>
      <div class="nav">
        <publicClassHeader ref="publicClass_header" />
      </div>
      <!-- 搜索 -->
      <div class="search">
        <input
          type="text"
          placeholder="搜索"
          v-model="searchValue"
          @keyup.enter="searchEnter"
          @focus="searchfocus(1)"
          @blur="searchblur(2)"
        />
      </div>
      <div class="ico_box">
        <div class="ico_box_00" @click="Personalover" v-if="!headerToken">
          登录
        </div>
        <div
          class="ico_box_00 ico_box_03"
          @mouseenter="isMobile ? null : Personalover()"
          @mouseleave="Personalout"
          v-else
        >
          <img
            :src="HeadUrl"
            alt=" 个人中心"
            v-if="HeadUrl"
            @click.stop="triggerMobile(0)"
          />
          <div v-else class="header_not" @click.stop="triggerMobile(0)"></div>
          <div class="Personal" v-if="Personal" @mouseleave="Personalout">
            <div class="center">
              <strong @click.stop="triggerMobile(0)"></strong>
            </div>
            <h2>
              <strong @click.stop="toChildPage(0)">{{ NickNam }}</strong>
            </h2>
            <div class="heng"></div>
            <ul>
              <li class="ico1">
                <strong @click.stop="toChildPage(1)">账户设置</strong>
              </li>
              <li class="ico2">
                <strong @click.stop="toChildPage(2)">我的课程</strong>
              </li>
              <li class="ico3">
                <strong @click.stop="toChildPage(3)">我的语言测试</strong>
              </li>
              <li class="ico4">
                <strong @click.stop="toChildPage(4)">收藏的题</strong>
              </li>
              <li class="ico6">
                <strong @click.stop="toChildPage(6)">激活兑换</strong>
              </li>
              <li class="ico5">
                <strong @click.stop="toChildPage(5)">我的通知</strong>
              </li>
            </ul>
            <div class="heng"></div>
            <p><strong @click.stop="cancellation">退出登录</strong></p>
          </div>
        </div>
        <div class="userTitle" v-if="NickNam">个人中心</div>
      </div>
    </div>
    <logins ref="login" />
  </div>
</template>

<script>
import logins from "../login.vue"; //引入子组件logins
import publicClassHeader from "../publicClass_header.vue"; //头部导航
import { isMobileDevice } from "@/common/utils.js";
export default {
  name: "Header",
  components: {
    publicClassHeader,
    logins
  },
  data() {
    return {
      logintc: false,
      alerts: false,
      Personal: false,
      mess: "",
      messages: "",
      messageL: "",
      UserInfo: "",
      NickNam: "",
      HeadUrl: "",
      timer: "",
      searchValue: "",
      headerToken: false,
      searchHot: [],
      isMobile: isMobileDevice()
    };
  },
  created() {
    // 一定要在create里面执行一下写的回车事件enterSearch(),否则会执行不了
    this.searchEnter();
    // this.searchHotS();
  },
  mounted: function() {
    //自动触发写入的函数
    var that = this;
    that.searchValue = that.$route.query.keyword;
    if (this.$cookies.isKey("token")) {
      var tokenkey = that.$cookies.get("token");
      this.tokenkey = that.$cookies.get("token");
      this.$refs.login.Messages(tokenkey);
      this.$refs.login.UserInfo(tokenkey);
      that.headerToken = true;
    } else {
      this.messages = "";
      this.messageL = "";
      this.NickNam = "";
      this.HeadUrl = "";
      that.headerToken = false;
    }
  },
  methods: {
    // 搜索
    searchClick(keywords) {
      // console.log(keywords)
      this.searchValue = keywords || this.searchValue;
      this.$parent.keyword = this.searchValue;
      // // console.log(this.searchValue)
      this.$router.push({
        path: "/search",
        query: {
          keyword: keywords || this.searchValue
        }
      });
    },
    searchfocus(e) {
      this.enter = e;
    },
    searchblur(e) {
      this.enter = e;
    },
    searchEnter() {
      document.onkeydown = e => {
        //13表示回车键，baseURI是当前页面的地址，为了更严谨，也可以加别的，可以打印e看一下
        if (e.keyCode === 13 && this.enter == 1) {
          //回车后执行搜索方法
          this.searchClick();
        }
      };
    },
    // searchHotS() {
    //   let that = this;
    //   this.$api.get(
    //     "https://schoolapi.eiceducation.com.cn/api/PageInfo?pageTypeId=35",
    //     "",
    //     res => {
    //       // console.log(res, 'res')
    //       if (res.data.code == 200) {
    //         that.searchHot = res.data.results;
    //       }
    //     }
    //   );
    // },
    // 课程跳转
    classover(index) {
      if (this.$cookies.isKey("token")) {
        this.$router.push({
          path: "/personalCentre/myMission"
        });
        this.$parent.index = "6";
        this.$parent.cur = "0";
        this.$parent.activeName = "3";
      } else {
        this.$refs.login.loginsqs(); // 调用子组件的方法childClick
      }
    },
    // 消息弹出
    alertsover(index) {
      this.Personal = false;
      if (this.$cookies.isKey("token")) {
        if (this.messageL) {
          this.alerts = true;
        } else {
          this.$router.push({
            path: "/personalCentre/notice"
          });
          this.$parent.cur = "2";
          this.$parent.activeName = 0;
        }
      } else {
        this.$refs.login.loginsqs(); // 调用子组件的方法childClick
      }
    },
    alertsAll() {
      this.$router.push({
        path: "/personalCentre/notice"
      });
      this.$parent.cur = "2";
      this.$parent.activeName = 0;
    },
    // 消息关闭
    alertout(index) {
      this.alerts = false;
    },
    // 个人
    Personalover(index) {
      this.alerts = false;
      if (this.$cookies.isKey("token")) {
        if (this.isMobile) {
          this.Personal = !this.Personal; // 移动端点击切换显示状态
        } else {
          this.Personal = true; // 电脑端移入显示
        }
      } else {
        this.$refs.login.loginsqs(); // 调用子组件的方法childClick
      }
    },
    Personalout(index) {
      this.Personal = false;
    },
    triggerMobile(index) {
      this.Personal = !this.Personal;
      this.$router.push({
            path: "/personalCentre/myMission"
          });
    },
    toChildPage(index) {
      switch (index) {
        case 0:
          this.$router.push({
            path: "/personalCentre/myMission"
          });
          break;
        case 1:
          this.$router.push({
            path: "/personalCentre/editor"
          });
          break;
        case 2:
          this.$router.push({
            path: "/personalCentre/myMission"
          });
          break;
        case 3:
          this.$router.push({
            path: "/personalCentre/myLanguage"
          });
          break;
        case 4:
          this.$router.push({
            path: "/personalCentre/collectTopic"
          });
          break;
        case 5:
          this.$router.push({
            path: "/personalCentre/notice"
          });
          break;
        case 6:
          this.$router.push({
            path: "/personalCentre/coupon"
          });
          break;
      }
      this.Personalout()
    },
    // 退出登录
    cancellation(index) {
      this.$cookies.remove("token");
      this.Personal = false;
      this.messages = "";
      this.messageL = "";
      this.NickNam = "";
      this.HeadUrl = "";
      this.$router.push("/index");
      this.headerToken = false;
    }
  }
};
</script>

<style scoped>
/* @import url("../../style/reset.css"); */
.header {
  width: 100%;
  height: 80px;
  height: 80px;
  box-shadow: 0px 1px 0px 0px #ececec;
  border-radius: 0px 0px 0px 0px;
  background: #ffffff;
}

.public_header {
  display: flex;
  justify-content: flex-start;
  min-width: 1200px;
  margin: 0 auto;
  width: 1200px;
}

.header_left {
  margin-top: 17px;
  width: 200px;
  margin-right: 30px;
}

.header_left img {
  display: block;
  width: 200px;
}

.nav {
  width: 680px;
  height: 80px;
}

.search {
  width: 200px;
  height: 42px;
  background: #ffffff;
  margin-top: 19px;
  margin-right: 38px;
}

.search input {
  box-sizing: border-box;
  width: 100%;
  height: 42px;
  background: #ffffff;
  border-radius: 21px;
  border: 1px solid #dddddd;
  padding-left: 20px;
  background: url(../../assets/index/search.png) 16px no-repeat;
  background-size: 24px 24px;
  padding-left: 48px;
  font-size: 16px;
}

.ico_box {
  display: flex;
  justify-content: space-around;
  margin-top: 14px;
  width: 52px;
  position: relative;
}

.ico_box .ico_box_00 {
  position: relative;
  cursor: pointer;
  width: 50px;
  height: 50px;
  background: #fbfbfb;
  border: 1px solid #d8d8d8;
  border-radius: 26px;
  color: #ff0659;
  font-size: 16px;
  line-height: 50px;
  text-align: center;
}
.header_not{
   width: 50px;
  height: 50px;
  border-radius: 26px;

}
.ico_box .ico_box_03 {
  border: 1px solid #ff0659;
  width: 50px;
  height: 50px;
}

.ico_box .ico_box_03 img {
  width: 50px;
  height: 50px;
  border-radius: 25px;
}

.ico_box .ico_box_03 .Personal {
  position: absolute;
  top: 0;
  right: -14px;
  width: 194px;
  height: 497px;
  background: url(../../assets/index/grxl.png) bottom no-repeat;
  z-index: 7;
}

.ico_box .ico_box_03 .center {
  width: 100%;
  height: 52px;
}

.ico_box .ico_box_03 .center strong {
  width: 80px;
  height: 50px;
  display: block;
  float: right;
  font-weight: normal;
  cursor: pointer;
}

.ico_box .ico_box_03 .Personal h2 {
  font-size: 14px;
  line-height: 22px;
  padding-top: 35px;
  padding-bottom: 16px;
  margin: 0 auto;
  font-weight: normal;
  text-align: center;
}

.ico_box .ico_box_03 .Personal h2 strong {
  color: #333;
  font-weight: normal;
  cursor: pointer;
}

.ico_box .ico_box_03 .Personal .heng {
  width: 146px;
  height: 3px;
  background: #f5f6f6;
  border-radius: 2px;
  margin: 0 auto;
}

.ico_box .ico_box_03 .Personal ul {
  width: 146px;
  margin: 0 auto;
  padding-top: 12px;
}

.ico_box .ico_box_03 .Personal ul li {
  margin-bottom: 16px;
}

.ico_box .ico_box_03 .Personal ul li strong {
  display: block;
  line-height: 30px;
  padding-left: 39px;
  font-size: 12px;
  color: #333333;
  font-weight: normal;
  cursor: pointer;
}

.ico_box .ico_box_03 .Personal ul li.ico1 {
  background: url(../../assets/index/icon_cs_default_0.png) left no-repeat;
}

.ico_box .ico_box_03 .Personal ul li.ico2 {
  background: url(../../assets/index/icon_order_default_0.png) left no-repeat;
}

.ico_box .ico_box_03 .Personal ul li.ico3 {
  background: url(../../assets/index/icon_learning_tasks_0.png) left no-repeat;
}

.ico_box .ico_box_03 .Personal ul li.ico4 {
  background: url(../../assets/index/icon_follow_default_0.png) left no-repeat;
}

.ico_box .ico_box_03 .Personal ul li.ico5 {
  background: url(../../assets/index/icon_notice_default_0.png) left no-repeat;
}

.ico_box .ico_box_03 .Personal ul li.ico6 {
  background: url(../../assets/index/icon_coupon_default_0.png) left no-repeat;
}

.ico_box .ico_box_03 .Personal p {
  width: 146px;
  margin: 0 auto;
  padding-top: 10px;
}

.ico_box .ico_box_03 .Personal p strong {
  display: block;
  line-height: 30px;
  padding-left: 39px;
  font-size: 12px;
  color: #333333;
  background: url(../../assets/index/out.png) left no-repeat;
  font-weight: normal;
  cursor: pointer;
}

.ico_box .userTitle {
  position: absolute;
  top: 20px;
  right: -60px;
  width: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/header/Header.vue